export default "__VITE_ASSET__CAju_l9v__"